<template>
  <div class="yk-course-container-main">
    <div class="yk-course-new-content clearfix">
      <div class="clearfix search-head-con">
        <el-input placeholder="请输入串讲视频标题" v-model="videoTitle" class="input-name-val" size="small"></el-input>
        <el-button type="primary" size="small" icon="el-icon-search" @click="getVideoList">搜索</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-plus-outline"
          @click="showSave()"
        >添加</el-button>
         <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-plus-outline"
          @click="videoTypeVisible = true"
        >视频类型管理</el-button>
      </div>
      <img
        :src="nodataImg"
        alt
        v-show="courseList.length==0"
        style="margin:100px auto 0px;display: block;"
      />
      <div class="yk-course-list hor clearfix">
        <template v-for="(li, key) in courseList">
          <el-card class="yk-course" :key="key">
            <div class="yk-course-go-new">
              <img
                class="yk-course-cover-new"
                v-if="li.docUrl"
                :src="li.docUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160'"
              />
              <img class="yk-course-cover-new" v-else :src="defaultCover" />
            </div>
            <div class="yk-course-new-name" :title="li.videoTitle">{{li.videoTitle}}</div>
            <div class="yk-course-teacher-name">{{li.teaName}}</div>
            <div class="yk-course-publish-new">
              <el-dropdown trigger="click" @command="onDropdownClickHandler">
                <el-button class="yk-course__control">
                  <i class="wl-icon-gengduoxiao"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type: 'edit', data: li}">
                    <span>编辑</span>
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'delete', data: li}">
                    <span>删除</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-card>
        </template>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100,200,500,1000]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          v-show="totalCount>0"
          style="text-align: center;"
        ></el-pagination>
        <div class="itemempty"></div>
        <div class="itemempty"></div>
        <div class="itemempty"></div>
      </div>
      <el-dialog
        title="添加串讲视频"
        :visible.sync="rdialogVisible"
        width="60%"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
      >
        <div class="material-form-detail clearfix">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="180px"
            class="demo-ruleForm"
          >
            <el-form-item label="视频标题:" prop="videoTitle">
              <el-input v-model="ruleForm.videoTitle" placeholder="视频标题"></el-input>
            </el-form-item>
            <el-form-item label="视频定义" prop="videoContent">
              <el-input type="textarea" :rows="5" v-model="ruleForm.videoContent"></el-input>
            </el-form-item>
            <el-form-item label="视频类型" prop="videoTypeId">
              <el-select v-model="ruleForm.videoTypeId" placeholder="请选择">
                <el-option
                  v-for="item in videoTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主讲教师：" prop="teaName">
              <el-input v-model="ruleForm.teaName" placeholder="主讲教师"></el-input>
            </el-form-item>
            <el-form-item label="主讲教师职务：" prop="teaPost">
              <el-input v-model="ruleForm.teaPost" placeholder="主讲教师职务"></el-input>
            </el-form-item>
            <el-form-item label="主讲教师头像：" prop="teaUrl">
              <oss-imagenewthumbnail
                :url="urlAliyunOSS"
                :files.sync="ruleForm.teaUrl"
                format="image"
                v-if="rdialogVisible"
                :count="1"
              ></oss-imagenewthumbnail>
            </el-form-item>
            <el-form-item label="主讲教师简介：" prop="teaIntroduce">
              <el-input type="textarea" :rows="5" v-model="ruleForm.teaIntroduce"></el-input>
            </el-form-item>

            <el-form-item label="视频" prop="file">
              <oss-videonewthumbnail
                :url="urlAliyunOSS"
                :fileInfo.sync="ruleForm.file"
                :files.sync="ruleForm.files"
                v-if="rdialogVisible"
              ></oss-videonewthumbnail>
            </el-form-item>

            <el-form-item label="是否展示" prop="isShow">
              <el-radio-group v-model="ruleForm.isShow">
                <el-radio :label="1">展示</el-radio>
                <el-radio :label="0">不展示</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="rdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="串讲视频类型管理"
        :visible.sync="videoTypeVisible"
        width="60%"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="videoTypeHandleClose"
      >
        <videoTypeList></videoTypeList>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="videoTypeHandleClose">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ImageNewThumbnail from "components/AliyunOSS/NewThumbnail.vue";
import videoNewThumbnail from "components/AliyunOSS/VideoUpload.vue";
import videoTypeList from "page/xSchool/56xSystemManager/videoTypeList.vue";
export default Vue.extend({
  name: "course-list",
  components: {
    "oss-videonewthumbnail": videoNewThumbnail,
    "oss-imagenewthumbnail": ImageNewThumbnail,
    // eslint-disable-next-line vue/no-unused-components
    videoTypeList: videoTypeList
  },
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      rdialogVisible: false,
      courseList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      isShowNull: false,
      nodataImg: require("assets/images/the-last-new-nodata-imag.png"),
      defaultCover: require("assets/images/news-bg.png"), // 默认封面
      videoTitle: "",
      teaName: "",
      rules: {
        videoTitle: [
          { required: true, message: "请输入串讲视频名称", trigger: "blur" }
        ],
        videoContent: [
          { required: true, message: "请输入串讲视频简介", trigger: "blur" }
        ],
        file: [{ required: true, message: "请添加串讲视频", trigger: "blur" }],
        teaName: [
          { required: true, message: "请输入主讲教师", trigger: "blur" }
        ],
        teaUrl: [
          { required: true, message: "请输入主讲教师头像", trigger: "blur" }
        ],
        teaPost: [
          { required: true, message: "请输入主讲职务", trigger: "blur" }
        ],
        teaIntroduce: [
          { required: true, message: "请输入主讲教师简介", trigger: "blur" }
        ],
        isShow: [
          { required: true, message: "请输入展示状态", trigger: "blur" }
        ],
        videoTypeId: [
          { required: true, message: "请输入串讲视频类型", trigger: "change" }
        ]
      },
      ruleForm: {
        id: "",
        videoTitle: "",
        videoContent: "",
        teaName: "",
        teaIntroduce: "",
        teaUrl: "",
        teaPost: "",
        file: {
          docId: "",
          docUrl: "",
          docTitle: "",
          docTimeLenght: ""
        },
        files: [],
        isShow: 1,
        videoTypeId: "",
        videoTypeName:""
      },
      // videoTypeList: [
      //   {
      //     label: "初级",
      //     value: 1
      //   },
      //   {
      //     label: "中级",
      //     value: 2
      //   },
      //   {
      //     label: "高级",
      //     value: 3
      //   },
      //   {
      //     label: "职业基础",
      //     value: 4
      //   },
      //   {
      //     label: "拓展课程",
      //     value: 5
      //   }
      // ],
      videoTypeVisible:false,
      videoTypeList:[]
    };
  },
  watch: {
    checkList(val) {
      console.log(val);
    }
  },
  created() {
    this.getVideoList();
    this.getVideoTypeAllList();
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  methods: {
    getVideoTypeAllList(){
      var that = this;
      that.$http
        .post("/api/XOrg/VideoType/getVideoTypeAllList",{})
        .then(rst => {
          if (rst.code > 0) {
            that.videoTypeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    onDropdownClickHandler(cos) {
      var that = this;
      switch (cos.type) {
        case "delete":
          var arr = [];
          arr.push(cos.data.id);
          that
            .$confirm("此操作将删除该串讲视频, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              that.$http
                .post("/api/XOrg/Video/deleteVideo", {
                  ids: arr
                })
                .then(rst => {
                  if (rst.code > 0) {
                    this.getVideoList();
                  } else {
                    that.$message.warning(rst.msg);
                  }
                });
            })
            .catch(() => {
              that.$message({
                type: "info",
                message: "已取消删除"
              });
            });
          break;
        case "edit":
          that.getCourseInfo(cos.data);
          break;
        default:
          // this.$message.error('');新增
          break;
      }
    },
    //获取教材详情
    getCourseInfo(data) {
      var that = this;
      this.ruleForm.id = data.id;
      this.ruleForm.videoTitle = data.videoTitle;
      this.ruleForm.videoContent = data.videoContent;
      this.ruleForm.teaName = data.teaName;
      this.ruleForm.teaIntroduce = data.teaIntroduce;
      this.ruleForm.teaUrl = data.teaUrl;
      this.ruleForm.teaPost = data.teaPost;
      this.ruleForm.file.docId = data.docId;
      this.ruleForm.file.docUrl = data.docUrl;
      this.ruleForm.file.docTitle = data.docTitle;
      this.ruleForm.isShow = data.isShow;
      this.ruleForm.videoTypeId = data.videoTypeId;
      this.ruleForm.videoTypeName = data.videoTypeName;
      that.rdialogVisible = true;
    },
    showSave() {
      this.rdialogVisible = true;
    },
    videoTypeHandleClose(){
      this.videoTypeVisible = false;
      this.getVideoTypeAllList();
    },
    handleClose() {
      this.ruleForm.id = "";
      this.ruleForm.videoTitle = "";
      this.ruleForm.videoContent = "";
      this.ruleForm.teaName = "";
      this.ruleForm.teaIntroduce = "";
      this.ruleForm.teaUrl = "";
      this.ruleForm.teaPost = "";
      this.ruleForm.file.docId = "";
      this.ruleForm.file.docUrl = "";
      this.ruleForm.file.docTitle = "";
      this.ruleForm.files = [];
      this.ruleForm.isShow = 1;
      this.ruleForm.videoTypeId = "";
      this.ruleForm.videoTypeName = "";
      this.rdialogVisible = false;
    },
    getVideoList() {
      var that = this;
      this.$http
        .post("/api/XOrg/Video/getVideoList", {
          videoTitle: this.videoTitle,
          teaName: this.teaName,
          certificateId:this.certificateId,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.courseList = rst.list;
            that.page = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
            if (rst.list.length == 0) {
              that.isShowNull = true;
            }
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getVideoList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getVideoList();
    },
    submitForm() {
      var that = this;
      that.isButton = false;
      that.$refs["ruleForm"].validate(valid => {
        if (valid) {
          that.addBookMaterialInfo();
        } else {
          that.isButton = true;
          return false;
        }
      });
    },
    addBookMaterialInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/Video/addOrEditVideo", {
          id: this.ruleForm.id,
          videoTitle: this.ruleForm.videoTitle,
          videoContent: this.ruleForm.videoContent,
          teaName: this.ruleForm.teaName,
          teaIntroduce: this.ruleForm.teaIntroduce,
          teaUrl: this.ruleForm.teaUrl,
          teaPost: this.ruleForm.teaPost,
          docId: this.ruleForm.file.docId,
          docUrl: this.ruleForm.file.docUrl,
          docTitle: this.ruleForm.file.docTitle,
          docTimeLenght: this.ruleForm.file.docTimeLenght,
          orderNumber: this.ruleForm.orderNumber,
          isShow: this.ruleForm.isShow,
          videoTypeId: this.ruleForm.videoTypeId,
          certificateId: this.certificateId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.getVideoList();
            that.handleClose();
            that.$message.success(rst.msg);
          }else{
            that.$message.warning(rst.msg);
          }
        });
    }
  }
});
</script>

<style lang="scss">
.yk-course-container-main {
  padding-bottom: 40px;
  position: relative;
  .search-head-con {
    position: fixed;
    top: 60px;
    right: 0px;
    height: 60px;
    width: calc(100% - 240px);
    z-index: 1000;
    background: #fff;
    text-align: right;
    text-align: right;
    line-height: 60px;
    .input-name-val {
      margin-right: 15px;
      width: 240px;
    }
  }
  .yk-course {
    .el-card__body {
      padding: 0;
    }
    .yk-course__control {
      padding: 0;
      border: 0;
      font-size: 20px;
    }
  }
  .material-form-detail {
    margin-left: 79px;
    width: 60%;
    .mater-form-file {
      .el-upload-list {
        float: left;
        background: #3f5880;
        width: 100%;
        border-radius: 4px;
        margin-bottom: 20px;
        .el-upload-list__item {
          margin: 0;
          padding: 6px 0;
          background: #415474;
          padding-left: 18px;
          .el-upload-list__item-name {
            color: #ffffff;
            padding-left: 0;
            .el-icon-document::before {
              color: #ffffff;
            }
          }
          .el-upload-list__item-status-label {
            top: 8px;
            right: 30px;
            border-radius: 4px;
            .el-icon-upload-success {
              color: #409eff;
            }
          }
          .el-icon-close {
            width: 13px;
            height: 13px;
            border-radius: 50%;
            background: #ee4166;
            top: 13px;
            right: 30px;
            font-size: 10px;
            line-height: 14px;
            text-align: center;
          }
          .el-icon-close-tip {
            display: none;
          }
        }
      }
      .el-upload__tip {
        display: inline-block;
        color: #ee4166;
        margin-top: 0;
      }
    }
  }

  .is-bordered {
    padding: 10px 10px 5px 10px;
  }
  .yk-course-new-content {
    .school-course-name {
      cursor: pointer;
      padding: 20px;
    }
    .school-course-active {
      color: #3fa2ff;
    }
    .yk-course-new-sortContent-new {
      text-align: right;
      position: fixed;
      right: 60px;
      top: 6px;
      z-index: 2000;
      .a-tea-work {
        font-size: 18px;
        width: 105px;
        text-decoration: none;
        color: #eeca1e;
        height: 32px;
        display: inline-block;
        text-align: center;
        line-height: 40px;
        border-radius: 3px;
        margin-right: 15px;
        i {
          font-size: 26px;
          float: left;
        }
      }
      .genduo {
        color: #409eff;
        font-size: 25px;
        position: relative;
        top: 5px;
        left: 3px;
      }
    }
    .yk-course-list {
      width: 100%;
      margin: 80px 0 0 30px;
      .yk-course-new-add {
        box-sizing: border-box;
        margin: 0px 16px 22px;
        margin-top: 40px;
        width: 372px;
        height: 320px;
        border: 2px dashed #409eff;
        border-radius: 10px;
        box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        .wl-icon-add-wrapper {
          margin-top: 85px;
          .wl-icon-tianjia {
            text-align: center;
            font-size: 100px;
            color: #409eff;
            border: 3px solid #409eff;
            border-radius: 50%;
          }
        }
        .yk-add-course-title {
          margin-top: 29px;
          font-size: 20px;
          color: #409eff;
          line-height: 1;
        }
      }
      .itemempty {
        margin: 0px 16px 22px;
        margin-top: 40px;
        width: 372px;
        height: 0;
      }
      .yk-course {
        position: relative;
        margin-top: 40px;
        width: 300px;
        height: 280px;
        border-radius: 10px;
        box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
        text-align: center;
        cursor: pointer;
        background-color: #fff;
        border: none;
        color: white;
        display: inline-block;
        margin: 0 16px 22px;
        text-decoration: none;
        .yk-course-go-new {
          width: 100%;
          height: 180px;
          .yk-course-cover-new {
            width: 100%;
            height: 180px;
            border-radius: 10px 10px 0 0;
          }
        }
        .yk-course-new-name {
          margin-top: 20px;
          font-size: 18px;
          color: #333333;
          width: 70%;
          margin-left: 15%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .yk-course-teacher-name {
          margin-top: 18px;
          color: #999999;
          font-size: 16px;
        }
        .yk-course-publish-new {
          position: absolute;
          right: 15px;
          bottom: 15px;
          .el-dropdown {
            button {
              background-color: rgba(255, 255, 255, 0.747);
              .wl-icon-gengduoxiao {
                font-size: 25px;
                color: #409eff;
              }
            }
          }
        }
      }
      .img-jp-icon {
        position: absolute;
        bottom: -25px;
        left: -16px;
      }
    }
  }
}
.left {
  float: left;
}
.right {
  float: right;
}
.clearfix::after {
  clear: both;
  display: block;
  content: "";
}
a {
  text-decoration: none;
}
</style>
